import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useFirmwaresStore = defineStore('firmwares', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getFirmwares: (state) => state.data?.data,
    getFirmwareCount: (state) => state.data?.total ?? 0,
    getFirmwareOptions: (state) => state.options?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexFirmwareOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'firmwares', ['id', 'version_number', 'device_type_id', 'device_model_id']);
          qryParams.include.push('deviceRevisions');
          const response = await axios.get('firmwares', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexFirmwares(params = {}) {
      try {
        const response = await axios.get('firmwares', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexFirmwareLookup(params = {}) {
      try {
        const response = await axios.get('firmware-lookup/firmwares', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createFirmware(params = {}) {
      try {
        const response = await axios.get('firmwares/create', {params});
        return useCreateForm(`firmwares`, {...response.data, firmware_file: null}, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showFirmware(firmwareId, params = {}) {
      try {
        const response = await axios.get(`firmwares/${ firmwareId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async exportFirmware(firmwareId, params = {}) {
      try {
        const response = await axios.post(`firmwares/${ firmwareId }/export`, params,
            {
              responseType: 'arraybuffer'
          }
        );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async exportFirmwareForLookup(firmwareId, params = {}) {
      try {
        const response = await axios.post(`firmware-lookup/firmwares/${ firmwareId }/export`, params,
            {
              responseType: 'arraybuffer'
            }
        );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editFirmware(firmwareId, params = {}) {
      try {
        const response = await axios.get(`firmwares/${ firmwareId }/edit`, {params});
        return useCreateForm(`firmwares/${ firmwareId }`, {...response.data, firmware_file: null, _method: 'PUT'}, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteFirmware(firmwareId, params = {}) {
      try {
        const response = await axios.delete(`firmwares/${ firmwareId }`, {params});
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Firmware Deleted',
          detail: `Firmware has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
